import React from "react";
import { Link } from "react-router-dom";

export const Taller = ({
  id = "",
  titulo = "",
  imagenes = "",
  precio = "",
}) => {
  // 1. PARCHE DE IMÁGENES: Convertimos el JSON de la DB a Array usable
  let imagenesArray = [];
  try {
    imagenesArray =
      typeof imagenes === "string" ? JSON.parse(imagenes || "[]") : imagenes;
  } catch (e) {
    imagenesArray = [];
  }

  return (
    <div className="talleres cajaDeCajas ps-2 pe-2" key={id}>
      <Link to={`/talleres/${id}/`}>
        <div className="cajaDeCajas">
          <div className="imgMedida caja">
            <div className="prueba img-container">
              {/* PROTECCIÓN: Solo renderiza si el array tiene datos */}
              {imagenesArray && imagenesArray.length > 0 ? (
                <img
                  src={imagenesArray[0].url}
                  alt={`Foto de ${titulo}`}
                  className="img-fluid mx-0 px-0"
                />
              ) : (
                <div
                  className="img-fluid mx-0 px-0 bg-secondary"
                  style={{ height: "200px" }}
                ></div>
              )}
            </div>
          </div>

          <h4 className="text-center negrita mt-2">{titulo}</h4>

          <p className="text-center pb-3">
            <span className="letraGris btnConsultar me-2">
              {/* Tu lógica de precio/inscripción original */}
              {Number(precio) === 0
                ? "consultar próximo comienzo >"
                : "inscripciones abiertas >"}
            </span>
          </p>
        </div>
      </Link>
    </div>
  );
};
